(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('feature-products-carousel-v2')) {
  customElements.define('feature-products-carousel-v2', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.pending = new MutationObserver(() => this.setup());
      this.pending.observe(this, { childList: true, subtree: true });
      this.setup();
    }

    setup() {
      if (!this.isConnected) return;
      const track = this.querySelector(':scope > .product-grid');
      const previous = this.querySelector('.side-arrow-controls button[name="previous"]');
      const next = this.querySelector('.side-arrow-controls button[name="next"]');
      if (!track || !previous || !next || !track.children.length) return;
      if (this.track === track && this.previous === previous && this.next === next && this.events) return;
      this.events?.abort();
      this.resize?.disconnect();
      this.track = track;
      this.previous = previous;
      this.next = next;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      previous.addEventListener('click', event => { event.preventDefault(); this.move(-1); }, options);
      next.addEventListener('click', event => { event.preventDefault(); this.move(1); }, options);
      track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      window.addEventListener('resize', () => this.update(), options);
      if (typeof ResizeObserver !== 'undefined') {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(track);
        Array.from(track.children).forEach(item => this.resize.observe(item));
      }
      this.update();
    }

    step() {
      const items = Array.from(this.track.children).filter(item => item.offsetWidth > 0);
      // Layout offsets are unaffected by reveal-on-scroll transforms.
      if (items.length > 1) {
        const distance = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
        if (distance > 0) return distance;
      }
      return items[0]?.offsetWidth || this.track.clientWidth;
    }

    move(direction) {
      const step = this.step();
      if (!step) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({
        left: direction * step * (rtl ? -1 : 1),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    update() {
      if (!this.track || !this.previous || !this.next) return;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.min(maximum, Math.abs(this.track.scrollLeft));
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= maximum - 1;
      const current = this.querySelector('.slider-counter--current');
      const total = this.querySelector('.slider-counter--total');
      const step = this.step();
      if (step > 0) {
        const pages = Math.ceil(maximum / step) + 1;
        const page = Math.min(pages, Math.round(position / step) + 1);
        if (current && current.textContent !== String(page)) current.textContent = String(page);
        if (total && total.textContent !== String(pages)) total.textContent = String(pages);
      }
    }

    cleanup() {
      this.pending?.disconnect();
      this.resize?.disconnect();
      this.events?.abort();
      this.events = null;
    }

    disconnectedCallback() { this.cleanup(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initTakdhumMegaMenu = (root = document) => {
    const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!supportsHover.matches) return;

    root.querySelectorAll('.header--takdhum header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound === 'true') return;
      const details = menu.querySelector('details');
      if (!details) return;
      menu.dataset.hoverBound = 'true';
      let closeTimer;

      const openMenu = () => {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 120);
      };

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('focus', openMenu);
        summary.addEventListener('blur', (event) => {
          if (!details.contains(event.relatedTarget)) {
            closeMenu();
          }
        });
      }

      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) {
          closeMenu();
        }
      });
    });
  };

  const updateTakdhumNavWidth = () => {
    const navWrapper = document.querySelector('.header__nav-wrapper');
    if (!navWrapper) return;
    const navWidth = navWrapper.getBoundingClientRect().width;
    navWrapper.style.setProperty('--takdhum-nav-width', `${navWidth}px`);
    document.documentElement.style.setProperty('--takdhum-nav-width', `${navWidth}px`);
  };

  const handleSectionEvent = (event) => {
    initTakdhumMegaMenu(event.target);
    updateTakdhumNavWidth();
  };

  document.addEventListener('DOMContentLoaded', () => {
    initTakdhumMegaMenu(document);
    updateTakdhumNavWidth();
    if (!window.__takdhumNavResizeBound) {
      window.addEventListener('resize', updateTakdhumNavWidth);
      window.__takdhumNavResizeBound = true;
    }
  });
  document.addEventListener('shopify:section:load', handleSectionEvent);
  document.addEventListener('shopify:section:select', handleSectionEvent);

  } catch(e) { console.error(e); }
})();
})();
